import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import FieldSettingsContext from './FieldSettingsContext';
import FieldSettingsApi from './FieldSettingsApi';
import FieldSettingsService from './FieldSettingsService';
import IntegrationApi from '../integration/IntegrationApi';
import WorkerSettingApi from '../workerSettings/WorkerSettingsApi';
import FieldWorkerImageStatusesApi from '../fieldWorkerImageStatuses/FieldWorkerImageStatusesApi';
import WorkerSettingService from '../workerSettings/WorkerSettingsService';
import LocalStorageService from '../utilities/LocalStorageService';
import SessionStorageService from '../utilities/SessionStorageService';
import FieldApi from '../field/FieldApi';

import { messageUtility } from '../../utilities/messageUtility';
import { isNullOrEmpty, isNullOrUndefined } from '../../utilities/stringUtil';
import { setWaitTime, extractErrorMessage } from '../../utilities/commonUtil';
import EventManager, { EventType } from '../../utilities/EventManager';
import PrintUtility from '../../utilities/printUtility';
import { isManagerRoleId } from '../../utilities/roleUtility';
import StaticFileService from '../StaticFiles';
import {
  RADIO_BUTTON,
  DIALOG_STATUS,
  STATUS_CODE,
  TIME_OUT_TWO_SECOND,
  WORKER_IMAGE_CCUS_SYNCED_STATUS,
  CHECKBOX,
  FILE_CODE,
  INTEGRATION_SERVICES,
  CALL_FROM_PAGE,
  DATE_TIME_FORMAT,
} from '../../utilities/constants';
import dialogLoader from '../../utilities/dialogLoader';
import { FormInformationDialog } from '../../components/FormInformationDialog';

/**
 * 現場設定画面のstate管理用コンポーネント
 * */
export default class FieldSettingsStore extends React.Component {
  state = {
    isLoading: true, // API等でローディング中フラグ
    integrationServicesEnabled: false, // 顔認証機器使用可能フラグ
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示ステータス
    fieldId: null, // 現場ID
    settings: Object.create(null), // 現場設定情報
    integrationServices: [], // 連携サービス情報
    informationModal: {
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
      multilineText: false, // モーダルダイアログメッセージには複数の行がある場合
      rootClassName: null,
    },
    confirmationModal: {
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
      buttonClassName: null, // モーダルダイアログのボタンのクラス名
    },
    confirmAppStartModal: {
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
      buttonClassName: null, // モーダルダイアログのボタンのクラス名
      effectiveButtonClassName: 'btn--effective btn--disabled', // モーダルダイアログのボタンのクラス名
      confirmCheckbox: 0, // 顔認証機器のチェックOFFからONに変更フラグ
    },
    confirmAppEndModal: {
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
      buttonClassName: null, // モーダルダイアログのボタンのクラス名
      effectiveButtonClassName: null, // モーダルダイアログのボタンのクラス名
    },
    searchForm: {
      // 顔写真を認証機器に未連携のユーザー検索用プロパティ (プロパティの値については仕様書参考)
      offset: 0, // 検索時の初期件数
      workerImage: 1, // 顔写真が存在する
      workerImageCcusSyncedStatusList: [
        WORKER_IMAGE_CCUS_SYNCED_STATUS.notRegister,
      ], // 顔認証機器未連携
      hasError: 2, // 全て
    },
    isMonitoringInProgress: false, // 顔認証機器が登録されたか監視中フラグ
    pendingIntegrationServices: [], // 未登録の顔認証機器
    registrationErrors: [], // 顔認証機器の登録エラー
    initialKaorekoValue: false, // 設定修正する前の顔レコの値（serviceTypeOneIds仕様変更で導入）
    faceDeviceOnOffFlg: false, // 顔認証機器のチェックONかOFFのフラグ
    visibleDownloadErrorDialog: false, // ダウンロードダイアログの表示状態
    fieldAreaVisibilityFlg: false, // エリア設定表示フラグ
  };

  constructor(props) {
    super(props);
    this.isSubmittingFlag = false;
  }

  /**
   * ラジオボタンのON/OFF制御
   * @param {string} propertyName ステート内のプロパティ名
   * */
  toggle = propertyName => {
    this.setState(prevState => {
      let stateChange = Object.create(null);
      stateChange.settings = {
        ...prevState.settings,
      };
      if (prevState.settings[propertyName] === RADIO_BUTTON.On) {
        stateChange.settings[propertyName] = RADIO_BUTTON.Off;
      } else if (prevState.settings[propertyName] === RADIO_BUTTON.Off) {
        stateChange.settings[propertyName] = RADIO_BUTTON.On;
      }
      return stateChange;
    });
  };

  /**
   * recording_methodのトグル
   */
  toggleRecordingMethod = () => {
    this.toggle('recording_method');
  };

  /**
   * automatic_approval_flgのトグル
   */
  toggleAutomaticApproval = () => {
    this.toggle('automatic_approval_flg');
  };

  /**
   * use_check_in_reflect_to_result_flgのトグル
   */
  toggleCheckInReflectToResult = () => {
    this.setState(prevState => {
      if (prevState.settings.use_check_in_reflect_to_result_flg === RADIO_BUTTON.On) {
        return {
          dialogStatus: DIALOG_STATUS.offReflectResultDialogEnabled.id,
        };
      }
      const tomorrowDate = moment()
        .add(1, 'days')
        .format(DATE_TIME_FORMAT.slashDateFormat);

      return {
        settings: {
          ...prevState.settings,
          use_check_in_reflect_to_result_start_date:
            prevState.settings.defaultReflectResultFlg === RADIO_BUTTON.Off
              ? tomorrowDate
              : prevState.settings.use_check_in_reflect_to_result_start_date,
          use_check_in_reflect_to_result_flg: RADIO_BUTTON.On,
        },
      };
    });
  };

  offCheckInReflectToResult = () => {
    this.setState(
      prevState => ({
        settings: {
          ...prevState.settings,
          use_check_in_reflect_to_result_flg: RADIO_BUTTON.Off,
        },
        errorStartDate: '',
      }),
      this.closeDialog
    );
  };

  /**
   * spot_flgのトグル
   */
  toggleSpotFlg = () => {
    this.toggle('spot_flg');
  };

  /**
   * use_k_mobile_flgのトグル
   */
  toggleKMobileFlg = () => {
    this.toggleIntegrationService(INTEGRATION_SERVICES.kMobile.id);
    this.toggle('use_k_mobile_flg');
  };

  updateOriginalFieldId = field_id => {
    this.setState(prevState => {
      let settings = { ...prevState.settings };
      settings.original_field_id = field_id;
      return { settings };
    });
  };

  setReflectToResultStartDate = date => {
    this.setState(prevState => {
      let settings = { ...prevState.settings };
      settings.use_check_in_reflect_to_result_start_date = date;
      const tomorrowDate = moment()
        .add(1, 'days')
        .startOf('date');
      const isValid = moment(date).isBefore(moment(tomorrowDate));
      const errorStartDate = isValid
        ? messageUtility.getMessage('E-002-001-04')
        : '';
      return { settings, errorStartDate };
    });
  };

  /**
   * unidentified_logs_auto_send_flgのトグル
   */
  toggleUnidentifiedLogsAutoSend = () => {
    if (
      this.state.settings.unidentified_logs_auto_send_flg === RADIO_BUTTON.Off
    ) {
      let state = _.cloneDeep(this.state);
      this.showUnidentifiedLogsAutoSendDialog(state);
      this.setState(state);
    }
    this.toggle('unidentified_logs_auto_send_flg');
  };

  /**
   * 日またぎ時刻の変更 (時の部分)
   * @param {string} hours 選択した情報
   * */
  setTimeHours = hours => {
    this.setState(prevState => {
      let settings = { ...prevState.settings };
      settings.day_crossing_time.hours(hours);
      return { settings };
    });
  };

  /**
   * 日またぎ時刻の変更 (分の部分)
   * @param {string} minutes 選択した情報
   * */
  setTimeMinutes = minutes => {
    this.setState(prevState => {
      let settings = { ...prevState.settings };
      settings.day_crossing_time.minutes(minutes);
      return { settings };
    });
  };

  /**
   * 体温検出基準値の変更
   * @param {string} threshold 選択した情報
   * */
  setBodyTemperatureThreshold = threshold => {
    this.setState(prevState => {
      let settings = { ...prevState.settings };
      settings.body_temperature_threshold = threshold;
      return { settings };
    });
  };

  /**
   * 顔認証サービスのトグル
   * @param {string} integrationServiceId: 選択した外部連携サービスID
   * @param {string} serviceType: 選択した顔認証サービス種類
   * */
  toggleIntegrationService = (integrationServiceId) => {
    this.setState(prevState => {
      let currentIds = prevState.settings.integration_service_ids;
      if (isNullOrUndefined(currentIds)) {
        currentIds = [];
      }
      if (currentIds.includes(integrationServiceId)) {
        _.remove(currentIds, id => id == integrationServiceId);
        if(integrationServiceId === INTEGRATION_SERVICES.kaoReko.id){
          this.toggleUseWorkerEntranceAppFlg(false);
        }
      } else {
        currentIds.push(integrationServiceId);
      }

      return {
        settings: {
          ...prevState.settings,
          integration_service_ids: currentIds,
        },
      };
    });
  };

  toggleUseWorkerEntranceAppFlg = (forceValue = null) => {
    this.setState(prevState => ({
      settings: {
        ...prevState.settings,
        use_worker_entrance_app_flg: forceValue == null ? (prevState.settings.use_worker_entrance_app_flg ? 0 : 1) : forceValue ? 1 : 0
      }
    }));
  };

  setVisibleDownloadErrorDialog = value => {
    this.setState({ visibleDownloadErrorDialog: value });
  };

  downloadFile = (file_code, fileName) => {
    const params = { file_code };
    PrintUtility.printOrOpenBlob(
      async () => {
        return StaticFileService.files(params).then(response => {
          if (_.includes(response.type, 'octet-stream')) {
            const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
            return new Blob([bom, response], { type: 'application/pdf' });
          } else {
            this.setVisibleDownloadErrorDialog(true);
            return null;
          }
        });
      },
      fileName,
      FILE_CODE.PDF,
      false
    );
  };

  /**
   * 利用料金を確認し、利用を開始するチェックののトグル
   */
  toggleConfirmCheckbox = () => {
    let state = _.cloneDeep(this.state);
    let confirmAppStartModal = state.confirmAppStartModal;
    if (confirmAppStartModal.confirmCheckbox === CHECKBOX.Off) {
      confirmAppStartModal.confirmCheckbox = CHECKBOX.On;
      confirmAppStartModal.effectiveButtonClassName = 'btn--effective';
    } else {
      confirmAppStartModal.confirmCheckbox = CHECKBOX.Off;
      confirmAppStartModal.effectiveButtonClassName =
        'btn--effective btn--disabled';
    }
    this.setState(state);
  };
  /**
   * 顔レコ利用開始・終了ダイアログの表示判定
   * */
  checkFaceAppServiceStartEnd = () => {
    if (this.state.errorStartDate || this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    let state = _.cloneDeep(this.state);
    let currentKaorekoValue = state.settings.integration_service_ids.includes(INTEGRATION_SERVICES.kaoReko.id)
    state.isLoading = false;
    if (state.initialKaorekoValue && !currentKaorekoValue) {
      state = this.clearDialogStatus(state);
      state = this.showFaceAppUseEndDialog(state);
      state.faceDeviceOnOffFlg = false;
      this.isSubmittingFlag = false;
    } else if (
      !state.initialKaorekoValue && currentKaorekoValue
    ) {
      state = this.clearDialogStatus(state);
      state = this.showFaceAppUseStartDialog(state);
      state.faceDeviceOnOffFlg = true;
      this.isSubmittingFlag = false;
    } else {
      this.updateFieldSettings();
    }
    this.setState(state);
  };

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    let state = { ...this.state };
    let updateSuccess =
      state.dialogStatus === DIALOG_STATUS.updateSuccessDialogEnabled.id;
    state = this.clearDialogStatus(state);
    this.setState(state);

    if (!updateSuccess) {
      return;
    }

    let params = WorkerSettingService.createSearchWorkerSettingList(state.searchForm);
    params.call_from = CALL_FROM_PAGE.FIELD_SETTING_PAGE;

    Promise.all([
      WorkerSettingApi.fetchWorkerSettingList(
        state.fieldId,
        params
      ),
      FieldWorkerImageStatusesApi.registeredCount(state.fieldId),
    ])
      .then(responses => {
        if (!responses[0].result) {
          state = this.showErrorMessageDialog(state, responses[0]);
          return;
        }
        if (!responses[1].result) {
          state = this.showErrorMessageDialog(state, responses[1]);
          return;
        }
        // 未登録ユーザーが存在する場合、ダイアログを表示する
        let data_0 = responses[0].data;
        if (
          data_0.total > 0 &&
          state.settings.integration_service_ids.length > 0
        ) {
          state = this.showRegisterDialog(state);
          return;
        }
        // 未使用機器に連携済みがある場合、ダイアログを表示する
        let data_1 = responses[1].data;
        if (
          isNullOrEmpty(data_1.entities.field_worker_image_statuses) == false &&
          isNullOrEmpty(
            data_1.entities.field_worker_image_statuses.registered_counts
          ) == false &&
          data_1.entities.field_worker_image_statuses.registered_counts.filter(
            x =>
              state.settings.integration_service_ids.indexOf(
                x.integration_service_id
              ) < 0
          ).length > 0
        ) {
          state = this.showRegisterDialog(state);
          return;
        }
      })
      .catch(error => {
        state = this.showErrorMessageDialog(state, error);
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * 顔認証機器登録開始モーダルを表示する
   * @param {object} state: ステート情報
   * */
  showFaceAppUseStartDialog = state => {
    state.dialogStatus = DIALOG_STATUS.faceAppUseStartDialogEnabled.id;
    state.confirmAppStartModal.title = data.appUseStartDialog.title;
    state.confirmAppStartModal.message = data.appUseStartDialog.message;
    state.confirmAppStartModal.buttonText =
      data.appUseStartDialog.button.register;
    state.confirmAppStartModal.checkBoxText =
      data.appUseStartDialog.checkBoxText;
    return state;
  };
  /**
   * 顔認証機器登録終了モーダルを表示する
   * @param {object} state: ステート情報
   * */
  showFaceAppUseEndDialog = state => {
    state.dialogStatus = DIALOG_STATUS.faceAppUseEndDialogEnabled.id;
    state.confirmAppEndModal.title = data.appUseEndDialog.title;
    state.confirmAppEndModal.message = data.appUseEndDialog.message;
    state.confirmAppEndModal.buttonText = data.appUseEndDialog.button.register;
    return state;
  };

  /**
   * 更新成功モーダルを表示する
   * @param {object} state: ステート情報
   * */
  showUpdateSuccessDialog = state => {
    state.dialogStatus = DIALOG_STATUS.updateSuccessDialogEnabled.id;
    state.informationModal.title = data.title;
    state.informationModal.message = messageUtility.getMessage('I-000-003');
    state.informationModal.buttonText = data.button.close;
    return state;
  };

  /**
   * 顔画像登録開始モーダルを表示する
   * @param {object} state: ステート情報
   * */
  showRegisterStartDialog = state => {
    state.dialogStatus = DIALOG_STATUS.registerStartDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = messageUtility.getMessage('I-002-011-01');
    state.informationModal.buttonText = messageUtility.getMessage('I-000-017');
    state.informationModal.multilineText = true;
    return state;
  };

  /**
   * 顔認証機器登録モーダルを表示する
   * @param {object} state: ステート情報
   * */
  showRegisterDialog = state => {
    state.dialogStatus = DIALOG_STATUS.registerDialogEnabled.id;
    state.confirmationModal.title = data.confirmationDialog.title;
    state.confirmationModal.message = messageUtility.getMessage('I-002-012-02');
    state.confirmationModal.buttonText = data.button.send;
    state.confirmationModal.buttonClassName = data.class.register;
    return state;
  };

  /**
   * 現場未選択モーダルを表示する
   * @param {object} state: ステート情報
   * */
  showNotExistFieldIdDialog = state => {
    state.dialogStatus = DIALOG_STATUS.notExistFieldIdDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = messageUtility.getMessage('E-002-001-006');
    state.informationModal.buttonText = messageUtility.getMessage('I-000-017');
    return state;
  };

  /**
   * 不明な入退場の送信アラートモーダルを表示する
   * @param {object} state: ステート情報
   * */
  showUnidentifiedLogsAutoSendDialog = state => {
    state.dialogStatus = DIALOG_STATUS.unidentifiedLogsAutoSendDialogEnabled.id;
    state.informationModal.title = data.unidentifiedLogsAutoSendDialog.title;
    state.informationModal.message =
      data.unidentifiedLogsAutoSendDialog.message;
    state.informationModal.buttonText = data.button.close;
    state.informationModal.multilineText = true;
    state.informationModal.rootClassName = 'wide-dialog-md';
    return state;
  };

  /**
   * APIのエラーメッセージダイアログを表示する
   * @param {object} response レスポンスデータ
   * */
  showErrorMessageDialog = (state, response) => {
    state.dialogStatus = DIALOG_STATUS.otherErrorDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = extractErrorMessage(response);
    state.informationModal.buttonText = messageUtility.getMessage('I-000-017');
    return state;
  };

  /**
   * ダイアログ周りのステータスを初期化する
   * @param {object} state: ステート情報
   * */
  clearDialogStatus = state => {
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;
    state.informationModal.multilineText = false;
    state.informationModal.rootClassName = null;
    state.confirmationModal.message = null;
    state.confirmationModal.buttonText = null;
    state.confirmationModal.buttonClassName = null;
    state.confirmAppStartModal.confirmCheckbox = 0;
    state.confirmAppStartModal.effectiveButtonClassName =
      'btn--effective btn--disabled';
    return state;
  };

  /**
   * 現場設定を更新する
   * */
  updateFieldSettings = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    state = this.clearDialogStatus(state);
    this.setState(state);
    FieldSettingsApi.updateCheckInOutSettings(
      state.fieldId,
      state.settings.id,
      FieldSettingsService.createUpdateCheckInOutSettingsRequestParams(
        state.settings
      )
    )
      .then(response => {
        if (response.result) {
          if (response.status === STATUS_CODE.ok) {
            const selectedIntegrationServiceIds = [
              ...this.state.settings.integration_service_ids,
            ];
            state.settings = FieldSettingsService.parseFetchCheckInOutSettingsResponseData(
              response.data
            );
            state.errorStartDate = '';
            const registeredIntegrationServiceIds = _.reject(
              selectedIntegrationServiceIds,
              id => state.settings.integration_service_ids.includes(id)
            );
            state.settings.integration_service_ids = selectedIntegrationServiceIds;
            state.fieldAreaVisibilityFlg = !!state.settings.use_worker_entrance_app_flg && state.settings.integration_service_ids.includes(INTEGRATION_SERVICES.kaoReko.id)
            SessionStorageService.setSpotFlg(state.settings.spot_flg);
            SessionStorageService.setUseWorkerEntranceAppFlg(state.settings.use_worker_entrance_app_flg);
            EventManager.trigger(EventType.LAYOUT_UPDATE, {});
            this.setState(state);
            if (registeredIntegrationServiceIds.length > 0) {
              this.startRegisterStatusMonitoring(
                registeredIntegrationServiceIds
              );
            } else {
              state.initialKaorekoValue = state.settings.integration_service_ids.includes(INTEGRATION_SERVICES.kaoReko.id)
              state.isLoading = false;
              state = this.showUpdateSuccessDialog(state);
              this.setState(state);
            }
          } else {
            state = this.showErrorMessageDialog(state, response);
            state.isLoading = false;
            this.setState(state);
          }
        } else {
          const message = _.get(response, 'data.message');
          if (
            message === messageUtility.getMessage('E-002-001-05') ||
            message === messageUtility.getMessage('E-002-001-06')
          ) {
            const isConcurrentPermissionError =
              message === messageUtility.getMessage('E-002-001-06');
            return dialogLoader.show(FormInformationDialog, {
              title: messageUtility.getMessage(
                isConcurrentPermissionError ? 'E-000-167-01' : 'I-002-015-01'
              ),
              message,
              buttonText: messageUtility.getMessage(
                isConcurrentPermissionError ? 'I-000-017' : 'I-000-180'
              ),
              onClose: () => {
                window.location.reload();
              },
            });
          }
          state = this.showErrorMessageDialog(state, response);
          state.isLoading = false;
          this.setState(state);
        }
      })
      .catch(error => {
        state = this.showErrorMessageDialog(state, error);
        state.isLoading = false;
        this.setState(state);
      })
      .finally(() => {
        this.isSubmittingFlag = false;
      });
  };

  /**
   * 顔認証機器が登録されたか監視を始める
   * @param {Array.<number>} integrationServiceIds 顔認証機器のid
   */
  startRegisterStatusMonitoring = integrationServiceIds => {
    this.setState(
      {
        isMonitoringInProgress: true,
        pendingIntegrationServices: integrationServiceIds,
        registrationErrors: [],
      },
      () => {
        integrationServiceIds.forEach(integrationServiceId => {
          this.monitorRegisterStatus(integrationServiceId);
        });
      }
    );
  };

  /**
   * 顔認証機器が登録完了のハンドラ
   * @param {number} integrationServiceId 顔認証機器のid
   * @param {function} callback
   */
  handleRegistrationFinished = (integrationServiceId, callback) => {
    if (!this.state.isMonitoringInProgress) {
      return;
    }
    this.setState(prevState => {
      const filtered = prevState.pendingIntegrationServices.filter(
        id => id !== integrationServiceId
      );
      return {
        pendingIntegrationServices: filtered,
      };
    }, callback);
  };

  /**
   * 顔認証機器が登録成功のハンドラ
   * @param {number} integrationServiceId 顔認証機器のid
   */
  handleRegisterStatusSuccess = integrationServiceId => {
    this.handleRegistrationFinished(integrationServiceId, () => {
      if (this.state.pendingIntegrationServices.length == 0) {
        this.handleMonitoringFinished();
      }
    });
  };

  /**
   * 顔認証機器が登録失敗のハンドラ
   * @param {number} integrationServiceId 顔認証機器のid
   * @param {string} message エラーメッセージ
   */
  handleRegisterStatusFailure = (integrationServiceId, message) => {
    this.handleRegistrationFinished(integrationServiceId, () => {
      this.setState(
        prevState => {
          const integrationService = _.find(prevState.integrationServices, {
            id: integrationServiceId,
          });
          const formattedMessage = `${integrationService.name}：${message}`;
          return {
            registrationErrors: [
              ...prevState.registrationErrors,
              formattedMessage,
            ],
          };
        },
        () => {
          this.toggleIntegrationService(integrationServiceId);
          if (this.state.pendingIntegrationServices.length == 0) {
            this.handleMonitoringFinished();
          }
        }
      );
    });
  };

  /**
   * 顔認証機器が登録されたか監視完了のハンドラ
   */
  handleMonitoringFinished = () => {
    let state = { ...this.state };
    state.isLoading = false;
    state.isMonitoringInProgress = false;
    state.pendingIntegrationServices = [];
    if (this.state.registrationErrors.length == 0) {
      state = this.showUpdateSuccessDialog(state);
      state.initialKaorekoValue = state.settings.integration_service_ids.includes(INTEGRATION_SERVICES.kaoReko.id)
      this.setState(state);
    } else {
      state = this.showErrorMessageDialog(state, {
        message: this.state.registrationErrors.join('\n'),
      });
    }
    this.setState(state);
  };

  /**
   * 顔認証機器が登録されたか監視する
   * @param integrationServiceId 顔認証機器のid
   * */
  monitorRegisterStatus = integrationServiceId => {
    if (!this.state.isMonitoringInProgress) {
      return;
    }
    setWaitTime(TIME_OUT_TWO_SECOND)
      .then(() => {
        IntegrationApi.confirmIntegrationServiceRegistration(
          this.state.fieldId,
          integrationServiceId
        )
          .then(response => {
            if (response.result) {
              if (response.status === STATUS_CODE.ok) {
                this.handleRegisterStatusSuccess(integrationServiceId);
                return;
              } else if (response.status === STATUS_CODE.accepted) {
                this.monitorRegisterStatus(integrationServiceId);
                return;
              } else {
                this.invokeError(response);
              }
            } else {
              this.handleRegisterStatusFailure(
                integrationServiceId,
                response.message
              );
            }
          })
          .catch(error => {
            this.invokeError(error);
          });
      })
      .catch(error => {
        this.invokeError(error);
      });
  };

  /**
   * ラピーダ連携（顔画像登録）を実行
   * */
  registerFaceImages = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    state = this.clearDialogStatus(state);
    this.setState(state);
    WorkerSettingApi.registerFaceImages(state.fieldId)
      .then(response => {
        if (response.result) {
          state = this.showRegisterStartDialog(state);
        } else {
          state = this.showErrorMessageDialog(state, response);
        }
      })
      .catch(error => {
        state = this.showErrorMessageDialog(state, error);
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * ローディングフラグの変更
   * @param {boolean} isLoading 新しい値
   */
  setLoading = isLoading => {
    this.setState({ isLoading });
  };

  /**
   * エラーメッセージを対応する
   * @param {object} error エラー
   */
  invokeError = error => {
    let state = _.cloneDeep(this.state);
    state.isLoading = false;
    state = this.showErrorMessageDialog(state, error);
    this.setState(state);
  };

  /**
   * 顔認証機器を選択できるかどうか
   * @param {number} integrationServiceId 顔認証機器のid
   * @returns {boolean}
   */
  shouldBeDisabled = integrationServiceId => {
    const state = _.cloneDeep(this.state);
    const integrationService = state.integrationServices.find(
      service => service.id === integrationServiceId
    );

    if (integrationService && integrationService.need_ccus_flg) {
      return true;
    }

    if (
      integrationServiceId == INTEGRATION_SERVICES.kaoReko.id &&
      isManagerRoleId(LocalStorageService.getRoleId())
    ) {
      return true;
    }

    return false;
  };

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  componentDidMount() {
    let state = { ...this.state };

    state.fieldId = SessionStorageService.getFieldId();
    if (isNullOrEmpty(state.fieldId)) {
      state.isLoading = false;
      state = this.showNotExistFieldIdDialog(state);
      this.setState(state);
      return;
    }

    FieldSettingsApi.fetchCheckInOutSettings(state.fieldId)
      .then(response => {
        if (response.result) {
          state.settings = FieldSettingsService.parseFetchCheckInOutSettingsResponseData(
            response.data
          );
          state.errorStartDate = '';
          state.initialKaorekoValue = state.settings.integration_service_ids.includes(INTEGRATION_SERVICES.kaoReko.id)
          state.fieldAreaVisibilityFlg = !!state.settings.use_worker_entrance_app_flg && state.settings.integration_service_ids.includes(INTEGRATION_SERVICES.kaoReko.id)
          SessionStorageService.setSpotFlg(state.settings.spot_flg);
          SessionStorageService.setUseWorkerEntranceAppFlg(state.settings.use_worker_entrance_app_flg);
          EventManager.trigger(EventType.LAYOUT_UPDATE, {});
        } else {
          state = this.showErrorMessageDialog(state, response);
        }
      })
      .catch(error => {
        state = this.showErrorMessageDialog(state, error);
      })
      .finally(() => {
        FieldApi.loadField(state.fieldId)
          .then(response => {
            if (response.result) {
              state.integrationServicesEnabled = true;
              IntegrationApi.fetchIntegrationService(state.fieldId)
                .then(response => {
                  if (response.result) {
                    state.integrationServices =
                      response.data.entities.integration_services;
                  } else {
                    state = this.showErrorMessageDialog(state, response);
                  }
                })
                .catch(error => {
                  state = this.showErrorMessageDialog(state, error);
                })
                .finally(() => {
                  state.isLoading = false;
                  this.setState(state);
                });
            } else {
              state.isLoading = false;
              this.setState(state);
            }
          })
          .catch(error => {
            state = this.showErrorMessageDialog(state, error);
            state.isLoading = false;
            this.setState(state);
          });
      });
  }

  render() {
    return (
      <FieldSettingsContext.Provider
        value={{
          state: this.state,
          toggleAutomaticApproval: this.toggleAutomaticApproval,
          toggleCheckInReflectToResult: this.toggleCheckInReflectToResult,
          setReflectToResultStartDate: this.setReflectToResultStartDate,
          toggleRecordingMethod: this.toggleRecordingMethod,
          toggleSpotFlg: this.toggleSpotFlg,
          toggleKMobileFlg: this.toggleKMobileFlg,
          toggleUnidentifiedLogsAutoSend: this.toggleUnidentifiedLogsAutoSend,
          toggleIntegrationService: this.toggleIntegrationService,
          updateOriginalFieldId: this.updateOriginalFieldId,
          setTimeHours: this.setTimeHours,
          setTimeMinutes: this.setTimeMinutes,
          setBodyTemperatureThreshold: this.setBodyTemperatureThreshold,
          closeDialog: this.closeDialog,
          updateFieldSettings: this.updateFieldSettings,
          registerFaceImages: this.registerFaceImages,
          offCheckInReflectToResult: this.offCheckInReflectToResult,
          shouldBeDisabled: this.shouldBeDisabled,
          checkFaceAppServiceStartEnd: this.checkFaceAppServiceStartEnd,
          toggleConfirmCheckbox: this.toggleConfirmCheckbox,
          setVisibleDownloadErrorDialog: this.setVisibleDownloadErrorDialog,
          downloadFile: this.downloadFile,
          toggleUseWorkerEntranceAppFlg: this.toggleUseWorkerEntranceAppFlg,
        }}
      >
        {this.props.children}
      </FieldSettingsContext.Provider>
    );
  }
}

const data = {
  title: '現場設定',
  button: {
    send: '送信',
    update: '更新',
    close: '閉じる',
  },
  class: {
    register: 'btn--effective',
    update: 'btn--effective',
  },
  unidentifiedLogsAutoSendDialog: {
    title: '不明な入退場データのCCUS送信',
    message:
      '承認した場合には、不明な入退場データがCCUSに自動で送信されます。\n送信されたデータには所属会社や職種などの情報が設定されません。\n対象となる技能者については送信後、必ず施工体制への登録を行ってください。',
  },
  appUseStartDialog: {
    title: '顔レコ利用開始',
    checkBoxText: '利用料金を確認し、利用を開始する',
    message:
      '顔レコは課金対象の機能です。\n利用を開始する場合は利用規約および個人情報取り扱い\nをご確認ください。',
    button: {
      register: '利用を開始する',
    },
  },
  appUseEndDialog: {
    title: '顔レコ利用終了',
    message:
      '顔レコの利用を終了してよろしいですか？\nなお、利用を終了しても当月分の請求は発生します。',
    button: {
      register: '利用を終了する',
    },
  },
  confirmationDialog: {
    title: '顔写真情報の送信',
  },
};



// WEBPACK FOOTER //
// ./src/services/fieldSettings/FieldSettingsStore.js